// @flow
import { createSelector } from 'reselect';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import type { GlobalState } from '../rootReducer';
import { postChangePassword } from '../api/auth';

/* Action Types */
export const CHANGE_PASSWORD_FAIL = 'la/ui/ChangePassword/FAIL';
export const CHANGE_PASSWORD_REQUEST = 'la/ui/ChangePassword/REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'la/ui/ChangePassword/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: false,
    errorMessage: '',
    submitted: false,
    success: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case CHANGE_PASSWORD_FAIL:
            return {
                ...state,
                error: true,
                errorMessage: action.payload,
                submitted: false,
                success: false,
            };
        case CHANGE_PASSWORD_REQUEST:
            return {
                ...state,
                error: false,
                errorMessage: '',
                submitted: true,
                success: false,
            };
        case CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                error: false, // TODO: remove
                errorMessage: '', // TODO: remove
                submitted: false,
                success: true,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.changePassword;

export const getUiChangePassword = createSelector(stateSelector, state => state);

/* ACTION CREATORS */
export const changeUserPassword = (newPassword: string, oldPassword: string) => async (
    dispatch: Function,
    getState: Function,
) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        dispatch({
            type: CHANGE_PASSWORD_REQUEST,
        });
        await postChangePassword({ authToken, deployment, newPassword, oldPassword });
        dispatch({
            type: CHANGE_PASSWORD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: CHANGE_PASSWORD_FAIL,
        });
    }
};
